const jsonCloneDeep = (obj: unknown) =>
  obj !== undefined ? JSON.parse(JSON.stringify(obj)) : null;
export default jsonCloneDeep;
